import React from 'react';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';


import {
  CoreLink,
} from '../../../../components';

import './style.scss';

const PartnerPageTeaser = ({ entity }) => {
  return (
    <div className="PartnerPageTeaser">
      <div className="PartnerPageTeaser__image">
        <CoreLink className="overlapping-link" to={entity.getIn(['paths', DEFAULT_LANGUAGE])} />
        <div className="PartnerPageTeaser__image__wrapper">
          <Image
            src={entity.getIn(['field_image', 0, 'styles', 'teaser_image'])}
            className="PartnerPageTeaser__img"
            includeWebP
          />
        </div>
      </div>
      <h3>{entity.getIn(['title', 0, 'value'])}</h3>
    </div>
  );
};

export default PartnerPageTeaser;
